export default __webpack_public_path__ + "static/magly-6b7ba7783d0301b8b87577053a407d76.png";